import { useWorkflowContext } from 'app-context/worflow/WorkflowContext';
import RightSlider from 'component/hoc/rightSlider/RightSlider';
import CaptureForm from 'component/organism/workflow/forms/capture/CaptureForm';
import { FormikProvider, useFormik } from 'formik';
import { isEqual } from 'lodash';
import React, { useEffect } from 'react';
import toast from 'react-hot-toast';
import * as Yup from 'yup';

const CaptureModal = ({
  isOpen,
  data,
  onClose,
  title,
  id,
  isFetching,
  isError,
}) => {
  const {
    workflowData,
    setWorkflowData,
    selectedNode,
    initialWorkflowData,
    setIsChanged,
  } = useWorkflowContext();

  const formik = useFormik({
    initialValues: {
      variableId: selectedNode?.capture?.variableId || '',
      reassessIntent: selectedNode?.capture?.reassessIntent || false,
      hasSuggestions: selectedNode?.capture?.hasSuggestions || false,
      hasAIGenerated: selectedNode?.capture?.hasAIGenerated || false,
      suggestedQuestions: selectedNode?.capture?.suggestedQuestions?.map(
        (q, index) => {
          return {
            question: q.question || '',
          };
        }
      ) || [{ question: '' }],
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      variableId: Yup.string().required('variable Type is required'),
      reassessIntent: Yup.boolean(),
      hasSuggestions: Yup.boolean(),
      hasAIGenerated: Yup.boolean(),
      suggestedQuestions: Yup.array()
        .max(4, 'You can add up to 4 suggested questions only')
        .of(
          Yup.object().shape({
            question: Yup.string()
              .max(30, 'Question cannot exceed 30 characters')
              .required('Question is required'),
          })
        ),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {},
  });

  const handleSubmit = async () => {
    await formik.handleSubmit();
    try {
      setTimeout(() => {
        const updatedNodes = workflowData?.nodes?.map((node) =>
          node.id === id
            ? { ...node, capture: formik.values, is_Error: isError }
            : node
        );

        setWorkflowData((prev) => ({
          ...prev,
          nodes: updatedNodes,
        }));
        const initialNode = initialWorkflowData.find((node) => node?.id === id);
        if (initialNode) {
          const {
            variableId,
            reassessIntent,
            hasSuggestions,
            hasAIGenerated,
            suggestedQuestions,
          } = initialNode?.capture || {};

          const initialMessageObject = {
            variableId,
            reassessIntent,
            hasSuggestions,
            hasAIGenerated,
            suggestedQuestions: suggestedQuestions?.map((q) => ({
              question: q.question || '',
            })) || [{ question: '' }],
          };
          const currentValues = {
            variableId: formik.values.variableId,
            reassessIntent: formik.values.reassessIntent,
            hasSuggestions: formik.values.hasSuggestions,
            hasAIGenerated: formik.values.hasAIGenerated,
            suggestedQuestions: formik.values.suggestedQuestions,
          };
          const changed = !isEqual(currentValues, initialMessageObject);

          if (changed) {
            setIsChanged((prev) => {
              return prev.includes(id) ? prev : [...prev, id];
            });
          } else {
            setIsChanged((prev) => prev.filter((nodeId) => nodeId !== id));
          }
        }
        onClose();
        formik.resetForm();
      }, [100]);
    } catch {
      toast.error('Something went wrong');
    }
  };

  useEffect(() => {
    const updatedNodes = workflowData?.nodes?.map((node) =>
      node.id === id ? { ...node, is_Error: isError } : node
    );

    setWorkflowData((prev) => ({
      ...prev,
      nodes: updatedNodes,
    }));
  }, [isError]);

  useEffect(() => {
    if (isError) {
      formik.handleSubmit();
    }
  }, [isOpen]);
  return (
    <RightSlider
      title={title}
      action={{
        isOpen: isOpen,
        setIsOpen: handleSubmit,
      }}
    >
      <FormikProvider value={formik}>
        <CaptureForm data={data} isFetching={isFetching} />
      </FormikProvider>
    </RightSlider>
  );
};

export default CaptureModal;
